import { getIsItemHiddenCore } from './chunk-MFMTSPFX.mjs';

// src/helpers/factories/menuComboCardFactory.ts
var menuComboCardFactoryCore = (combos, categories, subcategories, menuTypes) => {
  return Object.values(combos).map((combo) => {
    var _a, _b;
    const categoryIdSet = /* @__PURE__ */ new Set();
    const subcategoryIdSet = /* @__PURE__ */ new Set();
    Object.values(combo.menuTypeVersions).forEach((menuTypeVersion) => {
      var _a2;
      Object.values((_a2 = menuTypeVersion.categoriesSubcategories) != null ? _a2 : {}).forEach(
        ({ categoryId, subcategoryId }) => {
          if (categoryId)
            categoryIdSet.add(categoryId);
          if (subcategoryId)
            subcategoryIdSet.add(subcategoryId);
        }
      );
    });
    return {
      id: combo.comboId,
      title: combo.name,
      locationsCount: (_b = (_a = combo.locationIds) == null ? void 0 : _a.length) != null ? _b : 0,
      categoryId: Array.from(categoryIdSet),
      subcategoryId: Array.from(subcategoryIdSet),
      menuTypeId: Object.values(combo.menuTypeVersions).map(
        (menuTypeVersion) => menuTypeVersion.menuTypeId
      ),
      isHidden: getIsItemHiddenCore(
        combo.menuTypeVersions,
        categories,
        subcategories,
        "combos",
        combo.comboId,
        menuTypes
      ),
      isActive: Object.values(combo.menuTypeVersions).some(
        (menuType) => menuType.active === true
      )
    };
  });
};

export { menuComboCardFactoryCore };
